import Alert from 'ui/Alert/Alert';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useLocalStorage } from 'helpers/reactUseHelper';
import { useTranslation } from 'react-i18next';

const StyPresentationAlert = styled(Alert, {
    name: 'StyPresentationAlert',
})(({ theme }) => ({
    margin: `0 ${theme.spacing(1)}`,
    '& .MuiAlert-message': {
        padding: 0,
        display: 'flex',
    },
}));

export const UserGroupsInformationAlert = () => {
    const { t } = useTranslation();
    const [showAlert, setShowAlert] = useLocalStorage<boolean>(
        'showUserGroupsInformationAlert',
        true,
    );

    const closeAlert = () => {
        setShowAlert(false);
    };

    return showAlert ? (
        <StyPresentationAlert
            severity="info"
            onClose={closeAlert}
            action={null}
        >
            {t('adminSpace.userGroupsList.alertMessage')}
        </StyPresentationAlert>
    ) : (
        <></>
    );
};
